import React, {Component} from 'react'
import {Row, Col, Card, CardHeader, CardBody, Button, Progress} from 'reactstrap'
import {AvForm, AvRadioGroup, AvRadio} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {graphql, withApollo} from 'react-apollo'
import DropzoneComponent from 'react-dropzone-component'
import UploadFiles from '../../utils/uploadFiles'
import {GET_JOBS} from '../JobsNotifications/graphql'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'

export class ImportWeldsForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      files: [],
      isSubmittingForm: false,
      submitFormProgress: 0,
    }

    this.djsConfig = {
      addRemoveLinks: true,
      autoProcessQueue: false,
      acceptedFiles: 'text/csv,.xlsx,.xls',
      maxFiles: 1,
    }
    this.componentConfig = {
      iconFiletypes: ['.csv', '.xlsx', '.xls'],
      showFiletypeIcon: true,
      postUrl: 'no-url',
    }
    this.dropzone = null

    this.submitFunction = this.submitFunction.bind(this)
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    formToggleFunction: PropTypes.func.isRequired,
    project_id: PropTypes.number.isRequired,
    client: PropTypes.object.isRequired
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/import_form') // GA TRACKER
  }

  uploadProgress(progressEvent) {
    let percentage = Math.round(progressEvent.loaded * 100.0 / progressEvent.total)
    this.setState({submitFormProgress: percentage})
  }

  submitFunction(e, values) {
    if (this.state.files.length === 0) {
      return alert('Please add a file')
    }
    this.setState({isSubmittingForm: true})

    this.props.mutate({
      variables: {
        type: 'WlWelds::Jobs::ImportWeld',
        project_id: this.props.project_id,
        args: values.type === 'synchronize' ? JSON.stringify({remove_difference: true}) : null
      }
    }).then(({data}) => {
      // withGaEvent({category: 'Import', action: 'import'}) // GA EVENT
      let import_id = data.createJobs.job.id
      // ADD FILE
      if (this.state.files.length > 0) {
        UploadFiles(import_id, 'Job', this.state.files,
          {onUploadProgress: this.uploadProgress.bind(this)}).then(() => {
          this.props.client.query({
            query: GET_JOBS,
            fetchPolicy: 'network-only'
          }).then(({ data }) => {
            const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
            const event = new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } })
            window.dispatchEvent(event)
          })
          this.props.formToggleFunction()
        })
      }
    })
  }

  handleFileAdded(file) {
    if (this.state.files.length === 0) {
      this.setState({files: [file]})
    }
  }

  handleFileRemoved(file) {
    if (file === this.state.files[0]) {
      this.setState({files: []})
    } else {
      alert('you can add only one file')
    }
  }

  render() {
    const config = this.componentConfig
    const djsConfig = this.djsConfig

    const eventHandlers = {
      init: dz => this.dropzone = dz,
      addedfile: this.handleFileAdded.bind(this),
      removedfile: this.handleFileRemoved.bind(this),
      maxfilesexceeded: (file) => {
        this.dropzone.removeFile(file)
      }
    }

    return (
      <div className="animated fadeIn">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader><b>Import Welds from file</b></CardHeader>
              <CardBody>
                <AvForm id="import-form" onValidSubmit={this.submitFunction} model={{type: 'incremental'}}>
                  <Col md="9">
                    <AvRadioGroup inline name="type" label="What you want to do ?" className="form-check-inline"
                      required>
                      <AvRadio label="Add new and update existing welds." value="incremental"/>  &nbsp;
                      <AvRadio label="Add new, update existing welds and remove the others." value="synchronize"/>
                    </AvRadioGroup>
                  </Col>
                  <DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig}/>
                  <br/>
                  <Button id="close-import-form-btn" color="danger" className="float-right" onClick={this.props.formToggleFunction}>
                    <i className="fa fa-close"/> Close
                  </Button>
                  <Button id="confirm-import-form-btn" type="submit" color="primary" className="float-right">
                    <i className="fa fa-arrow-down"/> Import
                  </Button>
                </AvForm>
                <Row><Col md="12">
                  {this.state.isSubmittingForm &&
                  <div>
                    <Progress className="progress-xs" value={this.state.submitFormProgress}/>
                    <small>{this.state.submitFormProgress}%</small>
                  </div>
                  }
                </Col></Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const CreateImportWelds = gql`
  mutation createJobs($project_id: Int, $type: String = "WlWelds::Jobs::ImportWeld", $args: String) {
    createJobs(project_id: $project_id, type: $type, args: $args) {
      job {
        id
      }
    }
  }
`
const CreateImportWeldsData = graphql(CreateImportWelds)(ImportWeldsForm)

export default withApollo(CreateImportWeldsData)



// WEBPACK FOOTER //
// ./src/components/Import/ImportWeldsForm.js